/**
 * @generated SignedSource<<fcaf5872cc367a3832494147c3291167>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UnlikeEpisodeInput = {
  episodeId: string;
  topicSlug: string;
};
export type LikedEpisodesPageUnlikeMutation$variables = {
  input: UnlikeEpisodeInput;
};
export type LikedEpisodesPageUnlikeMutation$data = {
  readonly unlikeEpisode: {
    readonly episode: {
      readonly id: string;
      readonly isLikedByViewer: boolean | null | undefined;
      readonly likeCount: number;
    } | null | undefined;
    readonly userErrors: ReadonlyArray<{
      readonly field: string | null | undefined;
      readonly message: string;
    }>;
  };
};
export type LikedEpisodesPageUnlikeMutation = {
  response: LikedEpisodesPageUnlikeMutation$data;
  variables: LikedEpisodesPageUnlikeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UnlikeEpisodePayload",
    "kind": "LinkedField",
    "name": "unlikeEpisode",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Episode",
        "kind": "LinkedField",
        "name": "episode",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isLikedByViewer",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "likeCount",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "userErrors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LikedEpisodesPageUnlikeMutation",
    "selections": (v1/*: any*/),
    "type": "MutationRoot",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LikedEpisodesPageUnlikeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d2611d4168d7a3ff1b82d6e96f565bf1",
    "id": null,
    "metadata": {},
    "name": "LikedEpisodesPageUnlikeMutation",
    "operationKind": "mutation",
    "text": "mutation LikedEpisodesPageUnlikeMutation(\n  $input: UnlikeEpisodeInput!\n) {\n  unlikeEpisode(input: $input) {\n    episode {\n      id\n      isLikedByViewer\n      likeCount\n    }\n    userErrors {\n      message\n      field\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8d59eaccd90e0cf8568bb4c85c267984";

export default node;
